import React, {
    useEffect,
    useState,
} from "react";
import ProductQuantity from "../ProductQuantity/ProductQuantity";
import {useParams} from "react-router";
import {ProductData, ProductShoppingCart} from "../Cart/cart.dto";
import {toast} from "@/components/ui/use-toast";
import {useCart} from "../Cart/CartContext";
import {FaCartPlus} from "react-icons/fa6";

function ProductTable({productData}: {
    productData: ProductData;
    horziontal?: boolean;
}) {
    const {cart, addToCart, updateCartItemQuantity} = useCart();
    const [cartItemIndex, setCartItemIndex] = useState(-1);
    const [cartQuantity, setCartQuantity] = useState<number | undefined>(undefined);
    
    useEffect(() => {
        if (cart) {
            const cartIndex = cart.items.stockItems.findIndex((i) => i.articleId === productData.id);

            setCartItemIndex(cartIndex);
            setCartQuantity(cartIndex !== -1 ? cart.items.stockItems[cartIndex].quantity : undefined);
        }
        
        if (cart) {
            const cartIndex = cart.items.transitItems.findIndex((i) => i.articleId === productData.id);

            setCartItemIndex(cartIndex);
            setCartQuantity(cartIndex !== -1 ? cart.items.transitItems[cartIndex].quantity : undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.items]);
    
    useEffect(() => {
        const stockItems = cart ? cart.items.stockItems : [];
        const transitItems = cart ? cart.items.transitItems : [];
        
        if (cart) {
            const stockIndex = stockItems.findIndex((i) => i.articleId === productData.id);
            const transitIndex = transitItems.findIndex((i) => i.articleId === productData.id);
            
            const finalIndex = transitIndex !== -1 ? transitIndex : stockIndex;
            const finalQuantity = transitIndex !== -1
                ? transitItems[transitIndex].quantity
                : stockIndex !== -1
                    ? stockItems[stockIndex].quantity
                    : undefined;

            setCartItemIndex(finalIndex);
            setCartQuantity(finalQuantity);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.items]);

    const [quantity, setQuantity] = useState(cartQuantity ?? 1);

    const queryParams = useParams();
    const isProductPage = queryParams.productId !== undefined;
    
    useEffect(() => {
        if (cartItemIndex !== -1) {
            updateCartItemQuantity(productData.id, quantity, productData.isTransit);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [quantity]);

    async function handleAddToCart(ev: React.MouseEvent<HTMLElement>) {
        ev.preventDefault();

        const newCartItem: ProductShoppingCart = {
            ...productData,
            articleId: productData.id,
            quantity,
            salesPrice: productData.salesPriceValue,
            salesUnit: productData.salesUnit,
        };

        try {
            await addToCart(newCartItem, productData.isTransit);
            toast({
                description: "Produs adaugat in cos cu success",
            });
            // const updatedCart = structuredClone(cart);
            //
            // if (productData.isTransit) {
            //     updatedCart.items.transitItems = [
            //         ...updatedCart.items.transitItems,
            //         newCartItem
            //     ] as ProductShoppingCart[];
            // } else {
            //     updatedCart.items.stockItems = [
            //         ...updatedCart.items.stockItems,
            //         newCartItem
            //     ] as ProductShoppingCart[];
            // }

            //await addToCart(updatedCart, productData.isTransit);
        } catch (error) {
            console.error("Failed to add item to cart:", error);
            toast({
                description: "A aparut o eroare. Va rugam incercati din nou.",
            });
        }
    }

    // if (props.horziontal === true)
    //   return (
    //     <ProductCardHorizontal
    //       productData={props.productData}
    //       AddToCartHandler={AddToCartHandler}
    //       cartQuantity={cartQuantity}
    //       isProductPage={isProductPage}
    //       quantityState={[quantity, SetQuantity]}
    //     />
    //   );

    return (
        <ProductTableRender
            productData={productData}
            handleAddToCart={handleAddToCart}
            cartQuantity={cartQuantity}
            isProductPage={isProductPage}
            quantityState={[quantity, setQuantity]}
        />
    );
}

function ProductTableRender({
                                productData,
                                cartQuantity,
                                quantityState,
                                handleAddToCart,
                            }: {
    productData: ProductData;
    isProductPage: boolean;
    cartQuantity: number | undefined;
    quantityState: [number, React.Dispatch<React.SetStateAction<number>>];
    handleAddToCart: (ev: React.MouseEvent<HTMLElement>) => void;
}) {
    let [quantity, setQuantity] = quantityState;
    
    return (
        <>
            <div className="text-center">
                <div className="flex flex-row">

                    {/* <div className={props.cartQuantity !== undefined ? "pt-1 p-1" : "pt-1 p-0.5"}> */}
                    <div className="w-1/2 mr-3">
                        <ProductQuantity quantity={quantity} productMultiplier={productData.multiplier}
                                         setQuantity={setQuantity} productData={productData}/>
                    </div>

                    <div className="bottom-0 my-auto">
                        {cartQuantity === undefined && (
                            <div
                                onClick={handleAddToCart}
                                className="flex justify-center text-center ml-14 rounded-md size-9 h-10 bg-red-500 text-white cursor-pointer"
                            >
                                <FaCartPlus className="bg-red my-auto text-center"/>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProductTable;
